var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5045 22V13.4805H21.9461L22.4611 10.1607H18.5032V8.041C18.5032 7.0796 18.8248 6.424 20.4848 6.424H22.6001V3.454C21.5756 3.36341 20.546 3.31934 19.5158 3.322C16.466 3.322 14.3785 4.8697 14.3785 7.711V10.1607H10.9262V13.4805H14.3772V22H1.79793C0.990462 22 0.336548 21.4566 0.336548 20.7856V1.2144C0.336548 0.5434 0.990462 0 1.79793 0H25.3494C26.1569 0 26.8108 0.5434 26.8108 1.2144V20.7856C26.8108 21.4566 26.1569 22 25.3494 22H18.5045Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeFacebook);
export default __webpack_public_path__ + "static/media/feFacebook.8bc50dd1dc945d2a1aa3ca68e81f8f6f.svg";
export { ForwardRef as ReactComponent };